export const TEST_EVENT_NAME = 'test_event';
export const DOWNLOAD_FLOW = 'download_flow';
export const DOWNLOAD_AGGREGATE = 'download_aggregate';
export const DOWNLOAD_TICKER_FLOW = 'download_ticker_flow';
export const OPC_BUILD_STRATEGY = 'opc_build_strategy';
export const FLOW_TOGGLE_SIDE_MODULE = 'flow_toggle_side_module';
export const CLICK_UPGRADE = 'click_upgrade';
export const SAVE_STRATEGIES = 'save_strategies';
